import api from "../api/axios";

const lookupService = { 
  getIller : () => api.get("lookups/iller"), 
  getIlceler : (ilId) => api.get(`lookups/ilceler?ilId=${ilId}`), 
  getKoyler : (ilceId) => api.get(`lookups/koyler?ilceId=${ilceId}`), 
};

export default lookupService;